var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTank = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 10.44C43.2667 4.5 38.3167 0 32.0833 0C28.9667 0 25.85 1.26 23.65 3.42C22.3667 4.68 21.45 5.94 20.9 7.56L31.1667 14.22V14.4H36.6667V18H31.1667V21.6H36.6667V25.2H31.1667V28.8H36.6667V32.4H31.1667V36H44V10.44ZM24.3833 9C25.4833 5.76 28.6 3.6 32.0833 3.6C35.5667 3.6 38.6833 5.76 39.7833 9H24.3833ZM0 16.2V36H9.16667V23.4H18.3333V36H27.5V16.2L13.75 7.2L0 16.2Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tank.b066b412ac74d208fd64bf29c1015d8c.svg";